import {
  DETAILS_TRANSACTIONS_CHARGEBACK,
  DETAILS_TRANSACTIONS_CHARGEBACK_ERROR,
  CLEAN_DETAILS_TRANSACTIONS_CHARGEBACK,
  CLEAN_DETAILS_TRANSACTIONS_CHARGEBACK_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function detailsTransactionsChargebackReducer(state = initialState, action) {
  switch (action.type) {
    case DETAILS_TRANSACTIONS_CHARGEBACK:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case DETAILS_TRANSACTIONS_CHARGEBACK_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_DETAILS_TRANSACTIONS_CHARGEBACK:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_DETAILS_TRANSACTIONS_CHARGEBACK_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };

    default:
      return state;
  }
}
